import { gql } from "graphql-request";

export const CREATE_CHAT_MUTATION = gql`
  mutation CreateChat($input: ChatCreateInput!) {
    createChat(input: $input) {
      data {
        _id
        title
        category
        createdAt
      }
    }
  }
`;

export const GET_CHATS_QUERY = gql`
  query GetChats($filter: ChatFilterInput) {
    chats(filter: $filter) {
      data {
        _id
        title
        category
        totalMessages
        lastActivityAt
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_CHAT_QUERY = gql`
  query GetChat($id: ID!) {
    chat(id: $id) {
      data {
        _id
        title
        category
        context
        firstMessageAt
        messages {
          _id
          content
          source
          messageOrder
          createdAt
          llmMetadata {
            model
            confidence
            mcpToolsUsed
            hasInternalData
            thinking
            processingSteps
            toolCalls {
              toolName
              name
              arguments
              args
              timestamp
              success
            }
          }
        }
      }
    }
  }
`;

export const SEND_MESSAGE_MUTATION = gql`
  mutation SendMessage($chatId: ID!, $input: ChatMessageInput!) {
    sendMessage(chatId: $chatId, input: $input) {
      data {
        _id
        title
        messages {
          _id
          content
          source
          messageOrder
          createdAt
          llmMetadata {
            model
            confidence
            mcpToolsUsed
            hasInternalData
          }
        }
      }
    }
  }
`;

export const SEND_MESSAGE_STREAMING_MUTATION = gql`
  mutation SendMessageStreaming($chatId: ID!, $input: StreamingChatMessageInput!) {
    sendMessageStreaming(chatId: $chatId, input: $input) {
      success
      chatId
      streamId
    }
  }
`;

export const CHAT_STREAM_SUBSCRIPTION = gql`
  subscription ChatStream($streamId: String!) {
    chatStream(streamId: $streamId) {
      type
      content
      metadata
      timestamp
      streamId
    }
  }
`;

export const UPDATE_CHAT_TITLE_MUTATION = gql`
  mutation UpdateChatTitle($id: ID!, $title: String!) {
    updateChat(id: $id, input: { title: $title }) {
      data {
        _id
        title
      }
    }
  }
`;

export const UPDATE_CHAT_CATEGORY_MUTATION = gql`
  mutation UpdateChatCategory($id: ID!, $category: ChatCategory!) {
    updateChat(id: $id, input: { category: $category }) {
      data {
        _id
        title
        category
      }
    }
  }
`;

export const DELETE_CHAT_MUTATION = gql`
  mutation DeleteChat($id: ID!) {
    deleteChat(id: $id) {
      data
    }
  }
`;
